export default __webpack_public_path__ + "static/media/5E6C9503-C2B8-424F-9E02-A838C9B86002_1_105_c.f50e0218.jpeg";